// IdTokenClaims.js
import React, { useEffect, useState } from "react";
import API_URL from "../config/config";
const IdTokenClaims = () => {
  const [idTokenClaims, setIdTokenClaims] = useState(null);

  useEffect(() => {
    const fetchIdTokenClaims = async () => {
      try {
        const response = await fetch(`${API_URL}/user/id`);

        if (response.ok) {
          const data = await response.json();
          setIdTokenClaims(data.idTokenClaims);
        }
      } catch (error) {
        console.error("Error fetching ID token claims:", error);
      }
    };

    fetchIdTokenClaims();
  }, []);

  if (!idTokenClaims) {
    return <div>Loading ID token claims...</div>;
  }

  return (
    <div>
      <h1>ID Token Claims</h1>
      <pre>{JSON.stringify(idTokenClaims, null, 2)}</pre>
    </div>
  );
};

export default IdTokenClaims;
